"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onSearchFilter = exports.SearchFilter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _FooterFilter = _interopRequireDefault(require("./FooterFilter"));
var _SearchTextFilter = _interopRequireDefault(require("./SearchTextFilter"));
var _Form = _interopRequireDefault(require("../../../Form"));
var _Icon = _interopRequireDefault(require("../../../Icon"));
var _TextInput = _interopRequireDefault(require("../../../TextInput"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var SearchFilter = exports.SearchFilter = function SearchFilter(_ref) {
  var setSelectedKeys = _ref.setSelectedKeys,
    selectedKeys = _ref.selectedKeys,
    confirm = _ref.confirm,
    clearFilters = _ref.clearFilters,
    locale = _ref.locale;
  var formRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (selectedKeys && selectedKeys[0]) {
      formRef.current.setFieldsValue({
        q: selectedKeys[0]
      });
    } else {
      formRef.current.setFieldsValue({
        q: ''
      });
    }
  }, [selectedKeys]);
  function onFormSubmit() {
    var q = formRef.current.getFieldValue('q');
    setSelectedKeys(q ? [q] : []);
    confirm();
  }
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-container"
  }, /*#__PURE__*/_react.default.createElement(_Form.default, {
    ref: formRef,
    onSubmit: onFormSubmit,
    colSpan: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24
    }
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Item, null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    name: "q",
    size: "small",
    suffix: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "search"
    })
  })))), /*#__PURE__*/_react.default.createElement(_FooterFilter.default, {
    locale: locale,
    confirm: onFormSubmit,
    clearFilters: clearFilters
  }));
};
var onSearchFilter = exports.onSearchFilter = function onSearchFilter(dataIndex, value, record) {
  return (0, _SearchTextFilter.default)(record[dataIndex], value);
};